import React, { useContext } from 'react';
import Dropdown from '@prisjakt/ui-dropdown-new';
import DropdownItem from '@prisjakt/ui-dropdown-new/src/item';
import { AppState } from 'src/reducers';
import { AppContext } from '@prisjakt/ui-app-context';
import * as S from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { offerSorting } from 'src/areas/product/actions/product';
import { getSortOptions, translateSort } from './utils';
import { SortOptionEnum } from './types';
import {
  getSortingFromUserSettings,
  saveSortingAsUserSettings,
} from '../offer-list-filters/utils';
import { useEffectOnMount } from 'src/hooks/useEffectOnMount';
import { defaultProductState } from 'src/areas/product/reducer';

const SortOptionsBase = (props: ISortOptionsBaseProps) => {
  const { compact } = props;
  const { t } = useContext(AppContext);
  const dispatch = useDispatch();

  const currentSort =
    useSelector((state: AppState) => getSortState(state)) ||
    defaultProductState.sorting;

  useEffectOnMount(() => {
    const storedSort = getSortingFromUserSettings();
    if (storedSort) {
      dispatch(offerSorting(storedSort));
    }
  });

  const sortOptions = getSortOptions(currentSort, compact);

  const sort = (selectedSort: SortOptionEnum) => {
    saveSortingAsUserSettings(selectedSort);
    dispatch(offerSorting(selectedSort));
  };
  const title = t('common', `sort.title`);
  const icon = <S.SortIconComponent />;

  const toggleElement = () => (
    <S.SortingOptionsButton variant="text" color="primary">
      <S.TabletDesktop>
        <S.ButtonText>{translateSort(t, currentSort)}</S.ButtonText>
      </S.TabletDesktop>
      <S.OnlyMobile title={title}>{icon}</S.OnlyMobile>
    </S.SortingOptionsButton>
  );

  return (
    <S.SortingOptions>
      <S.Label>{title}:</S.Label>
      <Dropdown
        grow="left"
        toggleElement={toggleElement()}
        variant="secondary"
        showArrow={!compact}
      >
        {sortOptions.map(sortOption => {
          const label = translateSort(t, sortOption);

          return compact ? (
            <S.RadioItem
              key={sortOption}
              name="radioSelection"
              id={sortOption}
              checked={sortOption === currentSort}
              current={sortOption === currentSort}
              onChange={() => sort(sortOption)}
            >
              {label}
            </S.RadioItem>
          ) : (
            <DropdownItem key={sortOption} onClick={() => sort(sortOption)}>
              {label}
            </DropdownItem>
          );
        })}
      </Dropdown>
    </S.SortingOptions>
  );
};

const getSortState = (state: AppState) => state.areas.product.sorting;

interface ISortOptionsBaseProps {
  compact?: boolean;
}

export default SortOptionsBase;
